// Libraries
import React, { useState, useContext, useEffect, Fragment } from 'react';

// Components
import ScreenInfo from '../../components/ScreenInfo';

// Services and Contexts
import LanguageContext from '../../contexts/LanguageContext';
import UserContext from '../../contexts/UserContext';

// Material-UI
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function UserDetails() {
  const { translate } = useContext(LanguageContext);
  const { user, setUser } = useContext(UserContext);
  const [errors, setErrors] = useState({});

  const handleInputChange = (input, event) => {
    const value = event.target.value;
    setUser({ ...user, [input]: value });
  };

  const handleCheckboxChange = (input, event) => {
    const value = event.target.checked;
    setUser({ ...user, [input]: value });
  };

  const handleValidateEmail = (event) => {
    const value = event.target.value;
    const re = /\S+@\S+\.\S+/;
    setErrors({ ...errors, email: !re.test(value) });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <ScreenInfo
        title="SCREEN_USER_DETAILS_TITLE"
        description="SCREEN_USER_DETAILS_INSTRUCTIONS"
      />
      <Box px={4}>
        <TextField
          value={user.name}
          variant="filled"
          placeholder={translate('UI_FORM_INPUT_NAME')}
          fullWidth
          helperText={translate('UI_FORM_INPUT_HELPER_NAME')}
          style={{ marginBottom: '1rem' }}
          onChange={(e) => handleInputChange('name', e)}
        />
        <TextField
          value={user.company}
          variant="filled"
          placeholder={translate('UI_FORM_INPUT_COMPANY')}
          fullWidth
          helperText={translate('UI_FORM_INPUT_HELPER_COMPANY')}
          style={{ marginBottom: '1rem' }}
          onChange={(e) => handleInputChange('company', e)}
        />
        <TextField
          value={user.operation}
          variant="filled"
          placeholder={translate('UI_FORM_INPUT_OPERATION')}
          fullWidth
          helperText={translate('UI_FORM_INPUT_HELPER_OPERATION')}
          style={{ marginBottom: '1rem' }}
          onChange={(e) => handleInputChange('operation', e)}
        />
        <TextField
          value={user.position}
          variant="filled"
          placeholder={translate('UI_FORM_INPUT_POSITION')}
          fullWidth
          helperText={translate('UI_FORM_INPUT_HELPER_POSITION')}
          style={{ marginBottom: '1rem' }}
          onChange={(e) => handleInputChange('position', e)}
        />
        <TextField
          value={user.email}
          variant="filled"
          error={errors.email}
          onBlur={handleValidateEmail}
          placeholder={translate('UI_FORM_INPUT_EMAIL')}
          fullWidth
          helperText={
            errors.email
              ? translate('UI_FORM_INPUT_HELPER_EMAIL_ERROR')
              : translate('UI_FORM_INPUT_HELPER_EMAIL')
          }
          onChange={(e) => {
            if (errors.email) handleValidateEmail(e);
            handleInputChange('email', e);
          }}
        />
        <Box marginTop={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={user.tnc}
                name="checkedB"
                color="primary"
                onChange={(e) => handleCheckboxChange('tnc', e)}
              />
            }
            label={translate('UI_FORM_CHECKBOX_AGREE_TERMS_AND_CONDITIONS')}
          />
        </Box>
      </Box>
    </Fragment>
  );
}
